<template>

    <aside class="sidenav">


        <div class="logo" >
            <img src="@/assets/saven_logo.png" />
        </div>

        <div id="sidebarToggle" @click="$emit('toggleNav')">
            <IconRetractSideNav />
        </div>



        <div class="userinfo" @click="goProfile">
            <div class="user_settings"><iconSettings /></div>
            <span class="username">{{ username }}</span>
        </div>


        <div class="main_nav">
        <ul>
            <!--
            <li class="sidenav-item" v-bind:class="{active: isActiveFor(dashboardViewNames) }" >
                <router-link :to="'/'">
                    <iconDashboard /> <span class="nav_label">{{ $t('layouts.user.nav.home') }}</span>
                </router-link>
            </li>

            <li class="sidenav-item" v-bind:class="{active: isActiveFor(sightRefViewNames)}" v-if="showSightRefsSection">
                <router-link :to="'/refs'">
                    <iconRef class="icon_ref" /> <span class="nav_label">{{ $t('layouts.user.nav.refs') }}</span>
                </router-link>
            </li>
        -->

            <li class="sidenav-item" v-bind:class="{active: isActiveFor(positionsViewNames)}">
                <router-link :to="'/positions'">
                    <iconPosition /> <span class="nav_label">{{ $t('layouts.user.nav.positions') }}</span>
                </router-link>
            </li>
            <li class="sidenav-item" v-bind:class="{active: isActiveFor(evaluationsViewNames)}">
                <router-link :to="'/evaluations'">
                    <iconEval class="icon_eval" /> <span class="nav_label">{{ $t('layouts.user.nav.evaluations') }}</span>
                </router-link>
            </li>
        </ul>
        </div>

        <div class="trefle">
            <img src="@/assets/trefle_grey.png" />
        </div>
        <div class="bottom_menu">
            <!--
            <div class="bottom_menu_item locale_dropdown_container">
                <LocaleSwitcher v-if="localeSwitcherAccess" />
            </div>
            <div class="bottom_menu_item link_item" >
                <a target="_blank" href="http://saven.fr/aide-saven-selection/">
                     <iconHelp /> <span class="nav_label">{{ $t('layouts.user.nav.faq') }}</span>
                </a>
            </div>
            -->
        </div>
        <div class="logout" v-on:click="logout">
            <div class="logout_btn"  ><i class="zmdi zmdi-power"></i></div>
            <div  v-if="!isMiniSideBar" class="logout_txt">{{ $t('layouts.user.nav.logout') }}</div>
        </div>

    </aside>

</template>

<script>
import LogoSight from './logoSight'
import PictoSight from './pictoSight'
import LogoSaven from './logoSaven'
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'sideNav',
    props: ['isMiniSideBar'],
    components: {
        LogoSight,
        LogoSaven,
        PictoSight
    },
    data: function(){
        return {
            username: JSON.parse(localStorage.getItem('account')).user.username,
            userRole: JSON.parse(localStorage.getItem('account')).licence.account_type,
            currentRoute: this.$route.name,
            dashboardViewNames: ['Dashboard'],
            sightRefViewNames: ['RefIndex', 'RefNew', 'RefEdit'],
            positionsViewNames: ["PositionNew", "PositionIndex", "PositionCompare"],
            evaluationsViewNames: ['EvaluationsIndex', 'EvaluationsNew', 'EvaluationEdit'],
        }
    },
    methods: {
        logout: function () {
            this.$store.dispatch('UserStore/logout', {})
                .then(() => this.$router.push('/login'))
                .catch(err => console.log(err))
        },
        isActiveFor(viewNames){
            return viewNames.includes(this.currentRoute)
        },
        goProfile(){
            this.$router.push('/profile')
        }
    },
    computed: {
        localeSwitcherAccess() {
            return true
            // return userCanAccess('languages', 'english')
        },
        showSightRefsSection(){
            return userCanAccess('features', 'create_sight_ref')
        }
    },
    watch: {
            '$route' (to, from) {
                this.currentRoute = to.name
            }
        }
    }

</script>

<style lang="scss" >


.sidenav{
    background: $sidebar-bg-fallback;
    background: $sidebar-bg;
    display: flex;
    flex-direction: column;
    width: $sidebar-width;
    min-width: $sidebar-width;
    max-width: $sidebar-width;
    padding: 0 30px;
    position: relative;
    transition: .25s all;

    #sidebarToggle{
        position: absolute;
        left: 25px;
        top: 20px;
        cursor: pointer;
        svg{
            transform: rotate(0deg);
            width: 38px;
            height: 51px;
            fill: white;
            &:hover{
                fill: $info;
            }

        }
    }

    .logo{
        width: 100%;
        height:150px;
        text-align: center;
        padding-top: 65px;
        overflow: hidden;
        svg{
            width: 130px;
            fill: $white;
        }
        img{
            width: 150px;
        }
    }
    .userinfo{
        height: 70px;
        border-top: 1px solid #ffffff50;
        border-bottom: 1px solid #ffffff50;
        color: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
        .user_settings{
            width: 28px;
            height: 28px;
            background-color: $info;
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
            svg{
                padding-top:4px;
                width: 16px;
                fill: white;
            }
        }
        &:hover{
            svg{
                animation: rotating 2s linear infinite;
            }
        }

    }
    .main_nav{
        flex: 1;
        z-index: 1;
        .sidenav-item{
            a{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                height: 50px;
                line-height: 50px;
                color: $sidebar-link-color;
                font-weight: 500;
                transition: .2s all;
            }
            span{
                font-weight: 500;
            }
            svg{
                margin-right: 12px;
                width: 18px;
                max-height: 25px;
                fill: $sidebar-link-color;
                transition: .2s all;
                &.icon_eval, &.icon_ref{
                    width: 45px;
                    height: 45px;
                    margin-right: 0px;
                    margin-left: -13px;
                }
            }
            &:hover, &.active{
                a, svg{
                    color: $info;
                    fill: $info;
                    font-weight: 500;
                }
            }
        }
        .retract-icon{
            svg{
                width: 38px;
                max-height: 50px;
            }
        }
    }
    .bottom_menu{
        .bottom_menu_item{
            border-top: 1px solid #ffffff50;
            &:last-child{
                border-bottom: 1px solid #ffffff50;
            }
            &.locale_dropdown_container{
                padding: 8px 0;
            }
            &.link_item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                a{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    color: white;
                    span{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        height:50px;
                    }
                    svg{
                        margin-right: 12px;
                        width: 24px;
                        max-height: 25px;
                        fill: $sidebar-link-color;
                        transition: .2s all;
                    }
                }
            }
        }
    }

    .logout{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        .logout_btn{
            font-size: 1.5rem;
            color: $info;
            width: 45px;
            height: 45px;
            margin-right: 0px;
            margin-left: -13px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .zmdi{

        }
        .logout_txt{
            line-height: 50px;
            color: #fff;
            font-size: 1rem;
            font-weight: 500;
        }
        &:hover{
            .logout_txt{
                color: $info;
            }
        }
    }
    .toggle_app{
        position: relative;
        padding: 20px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .logout_btn{
            font-size: 1.5rem;
            position: absolute;
            left: 0;
        }
        .logout_txt{
            font-size: 1rem;
        }
        .logo_saven{
            // width: 80px;
            display: flex;
            font-weight: 800;
            color: white;
            vertical-align: middle;
            img{
                width: 80px;
            }
        }
        span{
            padding: 0 6px;
            text-transform: uppercase;
            &.toggle_app_btn{
                background: $sidebar-link-color;
                border-radius: 100%;
                min-height:25px;
                max-height:25px;
                min-width:25px;
                max-width:25px;
                text-align: center;
                cursor: pointer;
                padding: 0;
                line-height: 27px;
                margin-left: 12px;
                color: white;
            }
        }


    }
    .trefle{
        position: absolute;
        bottom: 60px;
        width: 395px;
        left: 10px;
        transition: .2s all;

    }
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#layout-user.mini-sidenav{
    .trefle{
        width: 54px;
        left: 0px;
    }
    .sidenav{
        width: $mini-sidebar-width;
        min-width: $mini-sidebar-width;
        max-width: $mini-sidebar-width;
        padding: 0 14px;
        transition: .25s all;
        .logo{
            height:80px;
            transition: .3s all;
            padding-top: 30px;
            img{
                width: 242px;
                max-width: 242px;
                padding-right: 68px;
            }
        }
        #sidebarToggle{
            position: static;
            // transition: .25s all;
            text-align: center;
            transform: rotate(180deg);
        }
        .main_nav{
            .sidenav-item{
                a{
                    justify-content: center;
                    position: relative;
                    &:hover{
                        .nav_label{
                            opacity: 1;
                            display: block;
                            left: 40px;
                        }
                    }
                }
                svg{
                    margin-right: 0;
                    width: 22px;
                    max-height: 28px;
                    transition: .3s all;
                    &.icon_eval, &.icon_ref{
                        width: 45px;
                        height: 45px;
                        margin-right: 0px;
                        margin-left: 0px;
                    }
                }
            }
        }
        .nav_label{
            opacity: 0;
            position: absolute;
            width: auto;
            min-width: 180px;
            transition: .3s all;
            z-index: 500;
            background: $sidebar-bg;
            left: -300px;
            padding: 0 30px;
            color: $white;

        }
        .bottom_menu{
            .bottom_menu_item{
                justify-content: center;
                position: relative;
                border: none;
                &:hover{
                    .nav_label{
                        opacity: 1;
                        display: block;
                        left: 40px;
                        height: 50px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                    }
                }
                svg{
                    margin-right: 0;
                    width: 22px;
                    max-height: 28px;
                    transition: .3s all;
                }
            }
            .locale_dropdown{
                width: 100%;
                min-width: 180px;
                .dropdown-trigger{
                    .flag_container{
                        padding-left: 6px;
                        span{
                            display: none;
                        }
                    }
                    i{
                        display: none;
                    }
                }
            }
        }

        .userinfo{
            border: none;
            height: 50px;
            justify-content: center;
            .user_settings{
                margin: 0;
            }
            .username{
                opacity: 0;
                position: absolute;
                width: auto;
                transition: .3s all;
                z-index: 500;
                background: $sidebar-bg;
                left: -300px;
                padding: 0 30px;
                color: $white;
            }
            &:hover{
                .username{
                    opacity: 1;
                    display: block;
                    left: 50px;
                }
            }
        }

    }
}


</style>